import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import cn from '@/utils/cn';

// Canonical shadcn badge. `success`/`warning`/`info` (status tints), the
// `danger` alias of `destructive`, and `neutral` (the pre-merge app default: a
// muted cream chip) preserve the pre-merge app Badge variants. Renders a <span>
// (not shadcn's <div>) so a badge can live in phrasing content without a
// DOM-nesting warning.
export const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        danger:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        neutral: 'border-line bg-cream text-ink',
        success: 'border-success/20 bg-success-tint text-success',
        warning: 'border-warning/30 bg-warning-tint text-ink',
        info: 'border-brand/20 bg-brand-tint text-brand',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
